import Page from 'flarum/common/components/Page';
import {initChat} from '@speareducation/talkjs';
import {isMobileWebview} from '../../util';
import AwayMessageSelector from './AwayMessageSelector';

export default class MessagesPage extends Page {

  state = {
    chat: null,
    inbox: null,
  };

  oninit(vnode) {
    console.log('MessagesPage.oninit');
    super.oninit(vnode);
    this.clearPopups();
  }

  oncreate(vnode) {
    console.log('MessagesPage.oncreate');
    super.oncreate(vnode);
    this.clearPopups();
  }

  clearPopups() {
    $('[id^=__talkjs_popup]').hide(); // Manually hide talkjs popups
  }

  /**
   * Mithril likes to re-render the entire page whenever `m.redraw()` is executed. This can sometimes cause the TalkJS iframe to refresh.
   * @returns {Promise<null>}
   */
  async loadChat() {
    this.clearPopups();

    try {

      if (!this.state.chat) {
        this.state.chat = await initChat();
      }

      // hide all popups -- this saves the state for future page loads.
      this.state.chat.session?.getPopups().forEach(p => p.hide());

      if (this.inboxIsMounted()) {
        return null; // iframe is on the page. do nothing.
      }

      const [existingInbox] = this.state.chat.session?.getInboxes() ?? [];
      if (existingInbox) {
        this.state.inbox = existingInbox;
        existingInbox.mount(this.element.getElementsByClassName('MessagesPage')[0]);
        return null; // TalkJS is loaded and has an inbox created, but it does not exist in Mithril state or on the page.
      }

      // Pre-checks done, continue to first page-load logic.

      const isMobile = isMobileWebview();

      setTimeout(() => {
        this.state.inbox = this.state.chat?.createInbox({
          theme: 'spear_default',
          showFeedHeader: !isMobile,
          selected: m.route.param('id') || undefined
        });

        this.state.inbox.onConversationSelected(this.onConversationSelected);
        this.state.inbox.mount(this.element.getElementsByClassName('MessagesPage')[0]);
      }, 500)

    } catch (e) {
      this.element.innerHTML = `${e}`;
    }
  }

  /**
   * Invoked when a conversation is selected from the inbox
   */
  async onConversationSelected(conversation) {
    document.dispatchEvent(new CustomEvent('onConversationSelected', {detail: { conversation: conversation}}));
  }

  /**
   * Mithril "reactivity" often reloads the component more frequently than it needs to.
   * In addition, the TalkJS SDK "inbox" state can be mounted on the element, but there's no way to determine it (inbox.isActive is different?)
   * Simplest solution seems to be to just check for the iframe.
   * @returns {boolean}
   */
  inboxIsMounted() {
    return $('#MessagesPage iframe').length > 0;
  }

  view() {
    console.log('MessagePage.view');
    this.loadChat();

    const classList = [
      'MessagesPage',
      'container',
    ];

    if ($('#spear-header--impasta-bar').is(':visible')) {
      classList.push('has-impasta-bar');
    }
    if ($('#spear-header').is(':visible')) {
      classList.push('has-spear-header');
    }
    if ($('#header').is(':visible')) {
      classList.push('has-nav');
    }

    return (
      <div class="container">
        <AwayMessageSelector/>
        <div id="MessagesPage" className={classList.join(' ')}>
          <h4 class="text-center container">Loading your messages...</h4>
        </div>
      </div>
    );
  }
}
